import { Link } from "@inertiajs/react";
import type { ColumnDef } from "@tanstack/react-table";
import { Edit } from "lucide-react";

import { Button } from "@/components/ui/button";
import { editOrganizationCategoryPath } from "@/routes";
import type { Category } from "@/types";

export const buildColumns = (
  organizationSlug: string,
): ColumnDef<Category>[] => [
  {
    accessorKey: "id",
    header: "ID",
    enableSorting: false,
  },
  {
    accessorKey: "name",
    header: "Nombre",
    enableSorting: false,
    cell: ({ row }) => (
      <span className="font-medium">{row.original.name}</span>
    ),
  },
  {
    accessorKey: "description",
    header: "Descripción",
    cell: ({ row }) => {
      const description = row.original.description;
      return description ? (
        <span className="text-sm text-muted-foreground max-w-[200px] truncate">
          {description}
        </span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "subcategories_count",
    header: "Subcategorías",
    enableSorting: false,
    cell: ({ row }) => {
      const count = row.original.subcategories_count ?? 0;
      return (
        <div className="flex items-center gap-2">
          <span className="font-medium">{count}</span>
          {count > 0 && (
            <span className="text-xs text-muted-foreground">items</span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "created_at",
    header: "Creado",
    enableSorting: false,
    cell: ({ row }) => {
      const date = row.original.created_at
        ? new Date(row.original.created_at)
        : new Date();
      return (
        <span className="text-sm text-muted-foreground">
          {date.toLocaleDateString()}
        </span>
      );
    },
  },
  {
    id: "actions",
    header: "Acciones",
    cell: ({ row }) => {
      const category = row.original;

      return (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link
              href={editOrganizationCategoryPath(organizationSlug, category)}
              onClick={(e) => e.stopPropagation()}
            >
              <Edit className="h-4 w-4" />
              Editar
            </Link>
          </Button>
        </div>
      );
    },
  },
];
